import { useEffect, useState } from "react";
import { Button, Alert, Image, Row, Col, Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "react-bootstrap-icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getWardByWardId } from "../../../../store/actions/wardsAction";
import ManageWard from "../ManageWard";
import grayBox from "../../../../assets/images/grayBox.png";
import smileEmoji from "../../../../assets/svg/Yellow_Flag.svg";
import greenBox from "../../../../assets/images/greenBox.png";
import blueBox from "../../../../assets/images/blueBox.png";
import yellowBox from "../../../../assets/images/yellow.png";
import EditImg from "../../../../assets/images/edit.png";
import ProfileImage from "../../../../assets/images/profile.svg";
import AvailableBeds from "../beds/AvailableBeds";
import OccupiedBeds from "../beds/OccupiedBeds";
import ReservedBeds from "../beds/ReservedBeds";
import Loader from "../../../common/loader/Loader";
// card
import Card from "react-bootstrap/Card";
import availableWard from "../../../../assets/images/availableWard.png";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";

// card
const WardProfileCard = () => {
  const admin = useSelector((state) => state.admin);
  console.log("admin", admin);
  const { adminDetail } = admin;
  const [key, setKey] = useState("availableBeds");
  const { wardId } = useParams();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const {
    isRecordUpdated,
    error: apiError,
    isLoader,
  } = useSelector((state) => state.wards);
  const { isBedRecordUpdated } = useSelector((state) => state.beds);

  const [wardDetail, setWardDetail] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [isShow, setIsShow] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getWardByWardId({ wardId })).then(({ payload }) => {
      console.log("data", payload);
      if (payload?.success) {
        setWardDetail(payload.data);
      }
    });
  }, []);
  useEffect(() => {
    if (isRecordUpdated) {
      dispatch(getWardByWardId({ wardId })).then(({ payload }) =>
        setWardDetail(payload.data)
      );
    }
  }, [isRecordUpdated]);
  useEffect(() => {
    if (isBedRecordUpdated) {
      dispatch(getWardByWardId({ wardId })).then(({ payload }) => {
        if (payload.success) {
          setWardDetail(payload.data);
          hideHandlerRes();
        } else {
          setIsShow(true);
        }
      });
    }
  }, [isBedRecordUpdated]);

  const hideHandle = () => {
    setModalShow(false);
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  return (
    <>
      <ManageWard
        show={modalShow}
        onHide={hideHandle}
        title={"Edit Ward"}
        selectWard={wardDetail}
        modalShow={modalShow}
        setModalShow={setModalShow}
        adminDetail={adminDetail}
      />
      <div className="d-flex justify-content-between">
        <div className="d-flex justify-content-start align-content-center align-items-center py-2 my-2">
          <h1
            className="text-muted"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            Manage Wards
          </h1>
          <ChevronRight className="arrowRight" />
          <h1 className="title text-secondary mt-1">Ward Detail</h1>
        </div>
        <div className="block-detail1">
          <Button
            className="btn-primary px-3"
            href="#"
            style={{ float: "right", color: "white" }}
            onClick={() => setModalShow(true)}
          >
            <img src={EditImg} /> Edit
          </Button>
        </div>
      </div>
      {isLoader && <Loader />}

      <div className="rowBoxDetail1 d-flex flex-wrap md-flex-row  ">
        <div className="w-100">
          <Row>
            <Col xs={6} md={1}>
              {" "}
              <p className="objKey" style={{ fontSize: "14px" }}>
                Ward Name :
              </p>
            </Col>
            <Col xs={6} md={2}>
              <p className="objValue px-0" style={{ fontSize: "14px" }}>
                {wardDetail?.name}
              </p>
            </Col>
            <Col xs={6} md={1}>
              {" "}
              <p className="objKey" style={{ fontSize: "14px" }}>
                Geography :
              </p>
            </Col>
            <Col xs={6} md={2}>
              <p className="objValue px-0" style={{ fontSize: "14px" }}>
                {wardDetail?.location}
              </p>
            </Col>
            <Col xs={6} md={2} className="classColorDetails">
              <p className="objValue px-0" style={{ fontSize: "14px",color:'#969DAB' }}>
                <span className="px-1">
                  <img className="pe-2" src={greenBox} />
                  Available: {wardDetail?.availableBeds}
                </span>
              </p>
            </Col>
            <Col xs={6} md={2}>
              <p className="objValue px-0" style={{ fontSize: "14px",color:'#969DAB' }}>
                <span className="px-1">
                  <img className="pe-2" src={blueBox} />
                  Occupied Beds: {wardDetail?.occupiedBeds}
                </span>
              </p>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={1}>
              {" "}
              <p className="objKey" style={{ fontSize: "14px" }}>
                Ward Type :
              </p>
            </Col>
            <Col xs={6} md={2}>
              <p className="objValue px-0" style={{ fontSize: "14px" }}>
                {wardDetail?.type}
              </p>
            </Col>
            <Col xs={6} md={1}>
              {" "}
              <p className="objKey" style={{ fontSize: "14px" }}>
                Total Beds :
              </p>
            </Col>
            <Col xs={6} md={2}>
              <p className="objValue px-0" style={{ fontSize: "14px" }}>
                {wardDetail?.numberOfBeds}
              </p>
            </Col>

            <Col xs={6} md={2} className="classColorDetails">
              <p className="objValue px-0" style={{ fontSize: "14px",color:'#969DAB' }}>
                <span className="px-1">
                  <img className="pe-2" src={yellowBox} />
                  Reserved Beds: {wardDetail?.reservedBeds}
                </span>
              </p>
            </Col>
            <Col xs={6} md={3}>
              <p className="objValue px-0" style={{ fontSize: "14px",color:'#969DAB' }}>
                <span className="px-1">
                  <img className="pe-2" src={smileEmoji} />
                  Today’s Expected Discharges: {wardDetail?.todayConfirmedDischarges}
                </span>
              </p>
            </Col>
          </Row>
        </div>
      </div>
      <div className="tab-block">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3 nav-item"
        >
          <Tab
            eventKey="availableBeds"
            className="mx-2 "
            title={`Available Beds (${
              wardDetail?.availableBeds ? wardDetail?.availableBeds : "0"
            })`}
          >
            <AvailableBeds />
          </Tab>
          <Tab
            eventKey="occupiedBeds"
            className="mx-2 "
            title={`Occupied Beds (${
              wardDetail?.occupiedBeds ? wardDetail?.occupiedBeds : "0"
            })`}
          >
            <OccupiedBeds />
          </Tab>
          <Tab
            eventKey="reservedBeds"
            className="mx-2 "
            title={`Reserved Beds (${
              wardDetail?.reservedBeds ? wardDetail?.reservedBeds : "0"
            })`}
          >
            <ReservedBeds />
          </Tab>
        </Tabs>
      </div>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordUpdated: isShow,
          successMsg: "loaded successfully",
          errorRes: apiError?.message,
        }}
      />
    </>
  );
};

export default WardProfileCard;
